"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.builder = exports.Outputs = exports.Capabilities = exports.Tensor = exports.Shape = exports.Builder = void 0;
var facade_1 = require("./facade");
Object.defineProperty(exports, "Builder", { enumerable: true, get: function () { return facade_1.Builder; } });
var Shape_1 = require("./Shape");
Object.defineProperty(exports, "Shape", { enumerable: true, get: function () { return __importDefault(Shape_1).default; } });
var Tensor_1 = require("./Tensor");
Object.defineProperty(exports, "Tensor", { enumerable: true, get: function () { return __importDefault(Tensor_1).default; } });
var facade_2 = require("./facade");
/**
 * A map of capability names to their identifies.
 */
exports.Capabilities = {
    "rand": 1,
    "sound": 2,
    "accel": 3,
    "image": 4,
    "raw": 5,
    "float-image": 6,
};
/**
 * A map of output names to their identifies.
 */
exports.Outputs = {
    "serial": 1,
    "tensor": 5,
};
/**
 * Use a high level builder API to initialize the Rune runtime.
 *
 * Check out the "Runtime" module if you need tighter control over the runtime
 * or want to avoid unnecessary indirection/copies.
 */
function builder() {
    return new facade_2.Builder();
}
exports.builder = builder;
